import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BannerAlertModule } from '../../molecules/banner-alert/banner-alert.module';
import { BannerFullimageModule } from '../../molecules/banner-fullimage/banner-fullimage.ui.module';
import { BannerIconModule } from '../../molecules/banner-icon/banner-icon.ui.module';
import { BannerSlimModule } from '../../molecules/banner-slim/banner-slim.ui.module';
import { BannerSplitComponent } from './banner-split/banner-split.component';
import { BannerHeadingComponent } from './dynamic-banner-shared/components/banner-heading/banner-heading.component';
import { BannerImageComponent } from './dynamic-banner-shared/components/banner-image/banner-image.component';
import { BannerTextComponent } from './dynamic-banner-shared/components/banner-text/banner-text.component';
import { DynamicBannerComponent } from './dynamic-banner.component';

@NgModule({
  imports: [
    CommonModule,
    BannerAlertModule,
    BannerSlimModule,
    BannerFullimageModule,
    BannerIconModule
  ],
  declarations: [
    BannerSplitComponent,
    BannerImageComponent,
    BannerHeadingComponent,
    BannerTextComponent,
    DynamicBannerComponent
  ],
  exports: [DynamicBannerComponent]
})
export class DynamicBannerUiModule {}
